
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { LatLng } from '~/utility/geo/GeoLocation'
import { CampsiteCategory } from '~/utility/types/CampsiteCategory'
import { BaseCampsiteCardProps, Photo } from './BaseCampsiteCardProps'

@Component
export default class BaseCampsiteCard
  extends Vue
  implements BaseCampsiteCardProps
{
  @Prop({ required: true })
    id: string
  @Prop({ required: true })
    name: string
  @Prop()
    availableToSearch: boolean
  @Prop()
    categories: CampsiteCategory[]
  @Prop()
    point: LatLng
  @Prop()
    isPointSearch: boolean
  @Prop()
    distance: { mi: number; km: number }
  @Prop()
    primaryPhoto: Photo
  @Prop()
    nutshells: string[]
  @Prop()
    rating: number
  @Prop()
    rating10: number
  @Prop()
    rateCount: number
  @Prop()
    hierarchyStringShort: string
  @Prop({ required: false })
    firstAvailableDate?: string
  @Prop({ required: true })
    status: 'bookable' | 'free'
  @Prop()
    expectedValue: number

  render() {
    return null
  }
}
